"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppPurchaseStoreType = void 0;
var InAppPurchaseStoreType;
(function (InAppPurchaseStoreType) {
    InAppPurchaseStoreType["GOOGLE_PLAY"] = "googlePlay";
    InAppPurchaseStoreType["APP_STORE"] = "appStore";
    InAppPurchaseStoreType["AMAZON_APP_STORE"] = "amazonAppstore";
    InAppPurchaseStoreType["ROKU_CHANNEL_STORE"] = "rokuChannelStore";
    InAppPurchaseStoreType["DIRECT_PAYMENTS"] = "directPayments";
    InAppPurchaseStoreType["EMPLOYEE_ACCESS"] = "employeeAccess";
})(InAppPurchaseStoreType = exports.InAppPurchaseStoreType || (exports.InAppPurchaseStoreType = {}));
